import css from 'styled-jsx/css';
import { colors } from '../../theme/theme';

const style = css`
  p {
    margin-bottom: 0;
    padding: 5px 8px;
    font-size: 14px;
    line-height: 14px;
    width: 60px;
    text-align: center;
    border-radius: 12px;
    color: #fff;
  }
  p.online {
    background: ${colors.device.online};
  }
  p.offline {
    background: ${colors.device.offline};
  }
`;

export default style;
